<template>
  <div class="rakuten-hotel-container">
    <!-- 헤더 -->
    <div class="page-header">
      <h1 class="fw-bold">라쿠텐 호텔 관리</h1>
      <div class="header-info">
        <span v-if="lastSyncDate" class="sync-info fs-6">
          최근 동기화: <span class="text-primary fw-bold">{{ this.getLocaleDateFormat(this.lastSyncDate) }}</span>
        </span>
      </div>
    </div>

    <!-- 검색 및 필터 영역 -->
    <div class="search-section">
      <div class="search-row">
        <!-- 페이지 크기 -->
        <div class="form-group">
          <label>페이지 크기</label>
          <select v-model="pageSize" @change="handlePageSizeChange" class="form-control">
            <option :value="50">50개</option>
            <option :value="100">100개</option>
            <option :value="500">500개</option>
            <option :value="1000">1000개</option>
          </select>
        </div> 

        <!-- 검색 버튼들 -->
        <div class="button-group">
          <button @click="getMyPropertyList" :disabled="loading" class="btn btn-primary">
            <i class="bi bi-cloud-check-fill"></i>
            {{ loading ? '조회중...' : '실시간 호텔리스트조회' }}
          </button>

          <button @click="getUpdatedProperties" :disabled="loading || !lastSyncDate" class="btn btn-warning">
            <i class="bi bi-eyeglasses"></i>
            변경이력있는 호텔리스트
          </button>

          <!-- 실시간 호텔리스트조회에 전체조회기능을 추가하여 불필요 -->
          <!-- <button @click="getAllProperties()" :disabled="loading" class="btn btn-warning">
            <i class="icon-download"></i>실시간 호텔전체리스트조회
          </button> -->

          <button @click="syncToDatabase" :disabled="loading || allHotels.length === 0" class="btn btn-success">
            <i class="bi bi-database-fill-add"></i>
            호텔정보저장
          </button>

          <!-- ✅ 추가: Rooms V2 동기화 버튼 -->
          <!-- <button @click="syncRoomsV2" :disabled="loading || !lastSyncDate" class="btn btn-info">
            <i class="bi bi-door-open-fill"></i>
            변경된 객실 동기화
          </button> -->
          
          <button @click="syncChanges" :disabled="loading || !lastSyncDate" class="btn btn-info">
            <i class="bi bi-arrow-repeat"></i>
            변경사항 통합 동기화
          </button>

          <button @click="syncFacilities" :disabled="loading" class="btn btn-dark">
            <i class="bi bi-building-gear"></i>
            시설코드 동기화
          </button>

          <!-- ✅ 추가: 전체 객실 초기 동기화 (최초 1회 또는 수동) -->
          <button @click="syncAllRoomsV2" :disabled="loading" class="btn btn-secondary" style="margin-left: 20px;">
            <i class="bi bi-house-door-fill"></i>
            전체 객실 초기동기화
          </button>
        </div>
      </div>
    </div> 

    <!-- 호텔판매 컨트롤 -->
    <div class="search-section2   ">
      <div class="search-row">
        <!-- 입력검색 -->
        <div class="form-group">
          <label>분류/정렬</label>
          <input v-model="searchKeyword" @input="handleSearch" type="text" class="form-control" placeholder="호텔명(국문/영문), 호텔ID"/>
        </div>

        <!-- 선택검색 -->
        <div class="form-group">
          <select class="form-control form-control-sm" v-model="state_province" @change="searchCityName">
            <option value="">지역명 리스트</option>
            <option :value="c.state_province" :key=i v-for="(c, i) in this.cityList">{{ c.pref_name_ko }}</option>
          </select>
        </div>

        <div class="form-group">
          <select class="form-control form-control-sm" v-model="typeCode" @change="searchHotelType">
            <option value="">숙소유형 리스트</option>
            <option :value="t.code" :key=i v-for="(t, i) in this.typeList">{{ t.label_ko }}</option>
          </select>
        </div>

        <div class="form-group">
          <select class="form-control form-control-sm" v-model="sFlag" @change="searchSalesStatus">
            <option value="">판매상태전체</option>
            <option value="Y">판매중</option>
            <option value="N">판매중지</option>
          </select>
        </div>

        <!-- 페이지 크기 -->
        <div class="form-group">
          <label>페이지 크기</label>
          <select v-model="pageSize" @change="handlePageSizeChange" class="form-control">
            <option :value="50">50개</option>
            <option :value="100">100개</option>
            <option :value="500">500개</option>
            <option :value="1000">1000개</option>
          </select>
        </div> 

        <!-- 컨트롤용 버튼 -->
        <div class="btnForAdmin">
          <button @click="loadHotelsFromDB" :disabled="loading" class="btn" style="background-color: slateblue; color: white;">
            <i class="bi bi-megaphone-fill"></i>
            {{ loading ? '호출 중' : '저장된 호텔정보 재호출' }}
          </button>
        </div>
        
        <div class="form-group" style="padding-left: 10px; width:50px;">
          <label>전체마진</label>
          <input v-model="margin_all" type="number" class="form-control" placeholder="마진액/마진률"/>
        </div>

        <div class="form-group2">
          <label>원 / %</label>
          <select class="form-control form-control-sm" v-model="margin_all_M" style="width:50px;">
            <option value="A">원</option>
            <option value="P">%</option>
          </select>
        </div>

        <div class="btnForAdmin" style="padding-left: 0;">
          <button @click="setMargin" :disabled="loading" class="btn" style="background-color: rgb(17, 87, 119); color: white;">
            {{ loading ? '설정 중' : '마진저장' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 로딩 스피너 -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner">
        <div class="rakuten-spinner"></div>
        <p>{{ loadingMessage || '호텔 목록을 불러오는 중...' }}</p>
      </div>
    </div>

    <!-- 에러 메시지 -->
    <div v-if="error && !loading" class="error-alert">
      <div class="alert alert-danger">
        <i class="icon-error"></i>
        <strong>오류 발생!</strong> {{ error }}
        <button @click="error = null" class="close-btn">×</button>
      </div>
    </div>

    <!-- 결과 요약 -->
    <div v-if="!loading && !error && filteredHotels.length > 0" class="result-summary">
      <div class="summary-card">
        <h3>조회 결과</h3>
        <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">전체 호텔</span>
            <span class="stat-value">{{ allHotels.length }}개</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">검색 결과</span>
            <span class="stat-value">{{ filteredHotels.length }}개</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">현재 페이지</span>
            <span class="stat-value">{{ currentPage }} / {{ totalPages }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">선택 언어</span>
            <span class="stat-value">{{ getLanguageName(selectedLanguage) }}</span>
          </div>
          <div class="btnForAdmin">
            <button @click="updateParam" :disabled="loading" class="btn" style="background-color: brown; color: white; font-size: 1rem;">
              <i class="bi bi-floppy"></i>
              {{ loading ? '변경 중' : '체크된 호텔업데이트' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 호텔 목록 테이블 -->
    <div v-if="!loading && !error && paginatedHotels.length > 0" class="hotel-table-container">
      <table class="hotel-table">
        <thead>
          <tr>
            <th><input type="checkbox" v-model="allSelected" @change="allChoice()" /></th>
            <th>번호</th>
            <th>표시순서</th>
            <th>대표IMG</th>
            <th style="width: 100px;">유형</th>
            <th>호텔명</th>
            <th>호텔ID</th>
            <th>주소</th>
            <th>국가</th>
            <th>지역</th>
            <th>도시</th>
            <th>전화번호</th>
            <th>RKT상태</th>
            <th class="text-danger" style="width: 80px;">NTB판매</th>
            <th>호텔설명</th>
            <th>Rooms</th>
            <th>마진</th>
            <th> </th>
            <th>내부코멘트</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(hotel, index) in paginatedHotels" :key="hotel.id || index">
            <td>
              <input type="checkbox" v-model="hotel.checkFlag" :id="`chk_${index}`" name="checkedBox" />
            </td>
            
            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>

            <!-- 표시우선순위 -->
            <td>
              <input type="number" class="form-control form-control-sm" style="width: 80px; color:crimson;" v-model="hotel.dispOrder" />
            </td>
            
            <!-- 대표이미지 -->
            <td>
              <div class="thumb-wrap">
                <template v-if="hotel.heroImg && hotel.heroImg.length > 0">
                  <img :src="hotel.heroImg" alt="대표이미지" class="thumbnail" />
                  <div class="thumb-preview">
                    <img :src="hotel.heroImg" alt="원본이미지" />
                  </div>
                </template>
                <!-- <span v-else class="no-image">
                  <i class="bi bi-image text-secondary"></i>
                  <div style="font-size: 0.7rem; font-weight: bold; color: gray;">no-image</div>
                </span> -->
              </div>
            </td>

            <!-- 호텔유형 -->
            <td style="width:100px;">
              <span style="font-size: 0.9rem; text-align: center; color:cadetblue;">{{ hotel.label || 'N/A' }}</span>
            </td>

            <!-- 호텔명 -->
            <td class="hotel-name">
              <strong>{{ hotel.name || 'N/A' }}</strong>
            </td>

            <!-- 호텔 ID -->
            <td>{{ hotel.id || 'N/A' }}</td>

            <!-- 주소 -->
            <td class="hotel-address">
              {{ hotel.address || '-' }}
            </td>

            <!-- 국가 -->
            <td>{{ hotel.country_code || '-' }}</td>

            <!-- 지역 -->
            <td>{{ hotel.state_province || '-' }}</td>

            <!-- 도시 -->
            <td>{{ hotel.city || '-' }}</td>
            
            <!-- 전화번호 -->
            <td>{{ hotel.phone || '-' }}</td>
            
            <!-- RKT상태 (is_property_opened) -->
            <td>
              <span class="status-badge status-active" v-if="hotel.is_property_opened == 'Y' || hotel.is_property_opened == true">
                Active
              </span>
              <span class="status-badge status-inactive" v-else>
                Inactive
              </span>              
            </td>
            
            <!-- NTB판매여부 (is_property_opened 기준) -->
            <td class="text-center">
              <span>
                <select class="form-control form-select-sm" v-model="hotel.salesFlag" 
                  :style="hotel.salesFlag === 'Y' ? 'color: #007bff; font-weight: bold;' : 'color: #dc3545; font-weight: bold;'">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </span>
            </td>

            <td>
              <button @click="viewDetail(hotel)" class="btn-action btn-view" title="호텔설명">
                <i class="bi bi-chat-left-text"></i>
              </button>
            </td>

            <td>
              <button @click="viewRooms(hotel.id, hotel.name)" class="btn-action btn-view2" title="룸상태보기">
                <i class="bi bi-search"></i>
              </button>
            </td>

            <!-- 호텔별 마진졍보 -->
            <td>
              <span>
                <input type="number" class="form-control form-control-sm text-end" style="width: 80px; color:crimson;" v-model="hotel.margin" />
              </span>
            </td>
            <td class="text-center">
              <span>
                <select class="form-control form-select-sm" v-model="hotel.marginMethod" 
                  :style="hotel.marginMethod === 'P' ? 'color: #007bff; font-weight: bold;' : 'color: #dc3545;'">
                  <option value="A">원</option>
                  <option value="P">%</option>
                </select>
              </span>
            </td>

            <!-- 내부관래용 코멘트 -->
            <td>
              <textarea v-model="hotel.adminMemo" class="form-control adminMemo" placeholder="비노출 내부용코멘트"></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 빈 결과 -->
    <div v-if="!loading && !error && allHotels.length === 0" class="empty-state">
      <div class="empty-icon">📭</div>
      <h3>호텔 데이터가 없습니다</h3>
      <p>조회 조건을 변경하거나 새로고침해주세요.</p>
      <button @click="loadHotelsFromDB()" class="btn btn-info">
        저장된 리스트 재호출
      </button>
    </div>

    <!-- 검색 결과 없음 -->
    <div v-if="!loading && !error && allHotels.length > 0 && filteredHotels.length === 0" class="empty-state">
      <div class="empty-icon">🔍</div>
      <h3>검색 결과가 없습니다</h3>
      <p>"{{ searchKeyword }}" 에 대한 검색 결과가 없습니다. 한글로 검색이 안되면 영문으로 검색을 해보세요.</p>
      <button @click="clearSearch()" class="btn btn-info">
        검색 초기화
      </button>
    </div>

    <!-- 페이지네이션 -->
    <div v-if="!loading && !error && filteredHotels.length > 0" class="pagination">
      <button @click="goToFirstPage()" :disabled="currentPage === 1" class="btn btn-pagination">
        <i class="bi bi-chevron-double-left"></i> 처음
      </button>

      <button @click="getPrevPage()" :disabled="currentPage === 1" class="btn btn-pagination">
        <i class="bi bi-arrow-left-circle-fill text-primary"></i> 이전
      </button>
      
      <span class="page-info">
        {{ currentPage }} / {{ totalPages }} 페이지
      </span>
      
      <button @click="getNextPage()" :disabled="currentPage === totalPages" class="btn btn-pagination">
        다음 <i class="bi bi-arrow-right-circle-fill text-primary"></i>
      </button>

      <button @click="goToLastPage()" :disabled="currentPage === totalPages" class="btn btn-pagination">
        마지막 <i class="bi bi-chevron-double-right"></i>
      </button>

      <!-- 페이지 직접 이동 -->
      <div class="page-jump">
        <input v-model.number="jumpToPage" @keyup.enter="jumpToPageNumber" type="number" 
          :min="1" 
          :max="totalPages"
          class="form-control page-input" placeholder="페이지"/>
        <button @click="jumpToPageNumber()" class="btn btn-pagination">이동</button>
      </div>
    </div>

    <!-- 호텔 상세 모달 -->
    <div v-if="selectedHotel" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2>{{ selectedHotel.name }}</h2>
          <button @click="closeModal" class="modal-close">×</button>
        </div>
        <div class="modal-body">
          <div class="detail-row">
            <label>호텔 ID:</label>
            <span>{{ selectedHotel.id }}</span>
          </div>
          <div class="detail-row">
            <label>호텔명:</label>
            <span>{{ selectedHotel.name }}</span>
          </div>
          <div class="detail-row">
            <label>체인명:</label>
            <span>{{ selectedHotel.chainName }}</span>
          </div>          
          <div class="detail-row">
            <label>주소:</label>
            <span>{{ selectedHotel.address || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>국가:</label>
            <span>{{ selectedHotel.country || '-' }} ({{ selectedHotel.country_code }})</span>
          </div>          
          <div class="detail-row">
            <label>지역:</label>
            <span>{{ selectedHotel.state_province || '-' }}</span>
          </div>          
          <div class="detail-row">
            <label>도시:</label>
            <span>{{ selectedHotel.city || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>전화번호:</label>
            <span>{{ selectedHotel.phone || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>이메일:</label>
            <span>{{ selectedHotel.email || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>웹사이트:</label>
            <span>{{ selectedHotel.website || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>평점:</label>
            <span>{{ selectedHotel.rating || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>체크인:</label>
            <span>{{ selectedHotel.check_in_time || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>체크아웃:</label>
            <span>{{ selectedHotel.check_out_time || '-' }}</span>
          </div>
          <div class="detail-row" v-if="selectedHotel.description">
            <label>설명:</label>
            <div class="hotel-description" v-html="selectedHotel.description"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn btn-secondary">닫기</button>
          <!-- <button @click="editHotel(selectedHotel)" class="btn btn-primary">수정</button> -->
        </div>
      </div>
    </div>

    <!-- 룸 상태 모달 -->
    <div v-if="selectedRoomHotel" class="modal-overlay" @click="closeRoomModal">
      <div class="modal-content" @click.stop style="max-width: 1000px;">
        <div class="modal-header">
          <h2 class="text-success fw-bold">{{ selectedRoomHotel.name }} — 객실 목록</h2>
          <button @click="closeRoomModal" class="modal-close">×</button>
        </div>
        <div class="modal-body">

          <div v-if="roomLoading" class="text-center py-4">
            <div class="rakuten-spinner" style="width:30px; height:30px;"></div>
            <p>객실 정보 불러오는 중...</p>
          </div>

          <table v-else-if="roomList.length > 0" class="hotel-table">
            <thead>
              <tr>
                <th>No</th>
                <th>객실코드</th>
                <th>객실명</th>
                <th>카테고리</th>
                <th>오픈여부</th>
                <th>성인(min/max)</th>
                <th>아동(min/max)</th>
                <th>수량</th>
                <th>전망</th>
                <th>금연</th>
                <th>층</th>
                <th>크기(㎡)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(room, i) in roomList" :key="room.room_id || i">
                <td>{{ i + 1 }}</td>
                <td>{{ room.room_code || '-' }}</td>
                <td>{{ room.title_translation || '-' }}</td>
                <td>{{ room.room_category || '-' }}</td>
                <td>
                  --
                  <!-- <span class="status-badge" :class="room.is_room_opened ? 'status-active' : 'status-inactive'">
                    {{ room.is_room_opened ? 'Open' : 'Closed' }}
                  </span> -->
                </td>
                <td class="text-center">{{ room.min_adult_occ || '-' }} / {{ room.max_adult_occ || '-' }}</td>
                <td class="text-center">{{ room.min_child_occ || '-' }} / {{ room.max_child_occ || '-' }}</td>
                <td class="text-center">{{ room.quantity || '-' }}</td>
                <td>{{ room.view_code || '-' }}</td>
                <td class="text-center">
                  <span v-if="room.non_smoking === 1" style="color:green;">✔</span>
                  <span v-else style="color:#ccc;">-</span>
                </td>
                <td>{{ room.floor || '-' }}</td>
                <td>{{ room.size_value || '-' }}</td>
              </tr>
            </tbody>
          </table>

          <div v-else class="text-center py-4">
            <p style="color: #999;">등록된 객실 정보가 없습니다.</p>
          </div>

        </div>
        <div class="modal-footer">
          <span style="font-size: 0.85rem; color: #888;">총 {{ roomList.length }}객실</span>
          <button @click="closeRoomModal" class="btn btn-secondary">닫기</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      allHotels: [],
      filteredHotels: [],
      currentPage: 1,
      pageSize: 100,
      jumpToPage: 1,
      searchKeyword: '',
      loading: false,
      loadingMessage: '',
      error: null,
      lastSyncDate: null,
      selectedHotel: null,
      selectedLanguage: 'ko-KR',
      //selectedLanguage: 'en-US',                // 영문으로 데이타를 연동해야 전체 데이타가 정상으로 들어옴
      allSelected: "N",
      state_province: "",                       // 지역명검색
      typeCode: "",                             // 숙소유형검색
      sFlag: "",                                // 판매상태검색

      cityList: [],
      typeList: [],                             // 숙소유형 리스트 (코드+라벨)

      selectedRoomHotel: null,
      roomList: [],
      roomLoading: false,      

      languageNames: {
        'ko-KR': '한국어',
        'ja-JP': '일본어',
        'en-US': '영어',
        'zh-CN': '중국어(간체)',
        'zh-TW': '중국어(번체)',
        'th-TH': '태국어',
        'vi-VN': '베트남어'
      },

      margin_all: 0,       // 전체 마진 설정값
      margin_all_M: "P",   // 마진 단위 (A: 원, P: %)
    }
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    // 라쿠텐 이미지 호스트 URL을 computed로 가져오기
    rakutenImageHost() {
      return this.$store.state.rakutenImageHost;
    },
    paginatedHotels() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredHotels.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredHotels.length / this.pageSize) || 1;
    },
    totalRecords() {
      return this.filteredHotels.length;
    }
  },

  created() {
    // this.user = this.$store.state.user;
    // console.log(`현재 사용자: ${this.user.handlerId}`)
    this.getLastSyncDate();
    this.getCityList()
    this.getTypeList()
    this.getMarginDefault();
    // console.log("rakutenImageHost:", this.rakutenImageHost)
  },

  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({ title: '로그인 필요', text: '접근권한 확인불가.', icon: 'error' });
      this.$router.push({path: '/'});
    }
    document.getElementById("user").style.display = "none";
    this.loadHotelsFromDB();
  },

  methods: {
    getDateFormat(date) { return this.$dateFormat(date); },

    getCurrencyFormat(value) {
      if(isNaN(value)) 
      { location.reload() }
      else 
      { return this.$currencyFormat(value); }
    },

    getLocaleDateFormat(date) { return this.$localeDateFormat(date); },

    getLanguageName(code) { return this.languageNames[code] || code; },

    async getCityList() {
      let cityList = await this.$api("/api/perfectrureList", { param: ["JP"] })
      
      if(cityList && cityList.length > 0) 
      {
        this.cityList = cityList
      }
      else {
        this.$swal({
          icon: 'warning',
          html: '도시 정보를 불러오지 못했습니다. 재시도 해주세요<br>반복되면 개발자에게 문의주세요'
        });
        return false;
      }
      console.log("도시 리스트:", this.cityList);
    },

    async getTypeList() {
      let typeList = await this.$api("/api/rakutenHotelType", {})
      
      if(typeList && typeList.length > 0) 
      {
        this.typeList = typeList
      }
      else {
        this.$swal({
          icon: 'warning',
          html: '숙소유형을 불러오지 못했습니다. 재시도 해주세요<br>반복되면 개발자에게 문의주세요'
        });
        return false;
      }
      //console.log("도시 리스트:", this.cityList);
    },

    // 기본마진 조회
    async getMarginDefault() {
      try {
        const result = await this.$api("/api/getHotelMarginDefault", {});
        if (result && result.length > 0) {
          this.margin_all   = result[0].margin;
          this.margin_all_M = result[0].marginMethod;
        }
      } catch (e) {
        console.error("기본마진 조회 오류:", e);
      }
    },

    // 중첩된 필터링을 위한 메소드
    applyFilters() {
      const keyword = this.searchKeyword.toLowerCase().trim();

      this.filteredHotels = this.allHotels.filter(hotel => {
        const cityMatch = !this.state_province  || hotel.state_province === this.state_province;
        const typeMatch = !this.typeCode  || hotel.category_id === this.typeCode;
        const salesMatch = !this.sFlag  || (this.sFlag === 'Y' ? (hotel.salesFlag === 'Y' || hotel.salesFlag == null) : hotel.salesFlag === 'N');
        const kwMatch   = !keyword || (
          (hotel.name           && hotel.name.toLowerCase().includes(keyword))            ||
          (hotel.city           && hotel.city.toLowerCase().includes(keyword))            ||
          (hotel.state_province && hotel.state_province.toLowerCase().includes(keyword))  ||
          (hotel.country        && hotel.country.toLowerCase().includes(keyword))         ||
          (hotel.country_code   && hotel.country_code.toLowerCase().includes(keyword))    ||
          (hotel.address        && hotel.address.toLowerCase().includes(keyword))         ||
          (hotel.id             && hotel.id.toLowerCase().includes(keyword))
        );
        return cityMatch && typeMatch && salesMatch && kwMatch;
      });
      this.currentPage = 1;
    },

    handleSearch() {
      this.applyFilters();
    },

    allChoice() {
      // 현재 페이지의 호텔만 선택/해제
      // this.paginatedHotels.forEach(hotel => {
      //   hotel.checkFlag = this.allSelected;
      // });
      if(this.allSelected)
      {
        this.paginatedHotels.forEach((id) => {
          id.checkFlag = true;
        })
      }
      else
      {
        this.paginatedHotels.forEach((id) => {
          id.checkFlag = false;
        })
      }
    },

    //전체호텔 마진일괄변경
    async setMargin() {
      let updateMarginAll = await this.$api("/api/updateHotelMargin_all", { param: 
        [ this.margin_all, this.margin_all_M, this.user.handlerId ]
      });

      if(updateMarginAll?.error) 
      {
        this.$swal({
          icon: 'error', title: '전체 마진 변경 실패',
          text: '데이터베이스 업데이트 중 오류가 발생했습니다. (' + (updateMarginAll.error.sqlMessage || '') + ') 재시도 해주세요.',
        });
      } 
      else 
      {
        this.$swal({
          icon: 'success', title: '전체 마진 변경 완료',
          text: `호텔마진설정이 변경되었습니다.`,
          timer: 2500, showConfirmButton: false
        });
        this.loadHotelsFromDB();
      }
    },

    // 시설동기화
    async syncFacilities() {
      const result = await this.$swal({
        title: '시설 코드 동기화',
        text: '라쿠텐 전체 시설 코드를 가져와 저장합니다.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '동기화',
        cancelButtonText: '취소'
      });

      if (!result.isConfirmed) return;

      this.loading = true;
      this.loadingMessage = '시설 코드 동기화 중...';

      try {
        const syncResult = await this.$api('/api/rakuten/syncFacilities', {
          param: [{ language: this.selectedLanguage }]
        });

        if (syncResult.success) {
          this.$swal({
            icon: 'success',
            title: '시설 코드 동기화 완료',
            text: `${syncResult.count}개 시설 코드가 저장되었습니다.`,
            timer: 2000, showConfirmButton: false
          });
        } else {
          throw new Error(syncResult.message || '동기화 실패');
        }
      } catch (e) {
        this.$swal({ icon: 'error', title: '동기화 실패', text: e.message });
      } finally {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    async updateParam() {
      const checkedHotels = this.paginatedHotels.filter(h => h.checkFlag);

      if (checkedHotels.length < 1) 
      {
        this.$swal({
          icon: 'warning', title: '선택된 호텔이 없습니다.',
          text: '변경처리할 호텔을 선택해주세요.',
          timer: 2000, showConfirmButton: false
        });
        return;
      }

      const updateData = checkedHotels.map(h => ({
        hotel_id:  h.hotel_id || h.id,
        salesFlag: h.salesFlag || 'Y',
        adminMemo: h.adminMemo || '',
        dispOrder: h.dispOrder || 999,
        margin:    Number(h.margin) || 0,
        marginMethod: h.marginMethod || 'A'
      }));

      //console.log('업데이트 데이터:', updateData);

      this.loading = true;
      this.loadingMessage = `${updateData.length}개 호텔 변경 중...`;

      let successCount = 0;
      let failCount = 0;

      // ✅ async/await 방식으로 통일
      for (let i = 0; i < updateData.length; i++) 
      {
        const item = updateData[i];
        try 
        {
          const result = await this.$api("/api/updateHotelControl", {
            param: [
              item.salesFlag,
              item.dispOrder,
              item.adminMemo,
              this.user.handlerId,
              item.margin,
              item.marginMethod,
              item.hotel_id
            ]
          });

          if (result.affectedRows > 0) 
          {
            console.log(`✅ 호텔ID ${item.hotel_id} 업데이트 성공`);
            successCount++;
          } 
          else 
          {
            console.error(`❌ 호텔ID ${item.hotel_id} 업데이트 실패:`, result.message);
            failCount++;
          }
        } 
        catch (error) 
        {
          console.error(`❌ 호텔ID ${item.hotel_id} 업데이트 오류:`, error);
          failCount++;
        }
      }

      // ✅ 성공 후 체크 해제
      if (successCount > 0) 
      {
        checkedHotels.forEach(h => { h.checkFlag = false; });
        this.allSelected = false;
      }

      this.loading = false;
      this.loadingMessage = '';

      this.$swal({
        icon: failCount === 0 ? 'success' : 'warning',
        title: '변경 완료!',
        html: `
          <div style="text-align:left;">
            <p>✅ 성공: <strong>${successCount}개</strong></p>
            <p>❌ 실패: <strong>${failCount}개</strong></p>
          </div>
        `,
        timer: failCount > 0 ? undefined : 2000,
        showConfirmButton: failCount > 0
      });
    },


    clearSearch() {
      this.searchKeyword = '';
      this.cityName      = '';
      this.typeCode      = '';
      this.applyFilters();
      // this.searchKeyword = '';
      // this.handleSearch();
    },

    handlePageSizeChange() {
      this.currentPage = 1;
    },

    getNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },

    getPrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },

    goToFirstPage() {
      this.currentPage = 1;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    goToLastPage() {
      this.currentPage = this.totalPages;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    jumpToPageNumber() {
      const pageNum = parseInt(this.jumpToPage);
      if (isNaN(pageNum) || pageNum < 1) {
        this.jumpToPage = 1;
        this.currentPage = 1;
      } else if (pageNum > this.totalPages) {
        this.jumpToPage = this.totalPages;
        this.currentPage = this.totalPages;
      } else {
        this.currentPage = pageNum;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // 도시명으로 검색
    searchCityName() {
      this.applyFilters();
      // if(this.cityName) 
      // {
      //   this.filteredHotels = this.allHotels.filter(hotel => hotel.city === this.cityName);
      // } 
      // else 
      // {
      //   this.filteredHotels = [...this.allHotels];
      // }
    },

    // 숙소유형으로 검색
    searchHotelType() {
      this.applyFilters();
      // if(this.typeCode) 
      // {
      //   this.filteredHotels = this.allHotels.filter(hotel => hotel.category_id === this.typeCode);
      // } 
      // else 
      // {
      //   this.filteredHotels = [...this.allHotels];
      // }
    },

    // 판매상태로 검색
    searchSalesStatus() {
      this.applyFilters();
    },

    async loadHotelsFromDB() {
      this.loading = true;
      this.loadingMessage = '저장된 호텔정보 호출 중...';
      try 
      {
        let rakutenHotelInfo = await this.$api("/api/rakutenHotelsInfo", {});
        //console.log("DB에서 조회된 호텔 정보:::::", rakutenHotelInfo);

        if (rakutenHotelInfo && rakutenHotelInfo.length > 0) 
        {
          this.allHotels = rakutenHotelInfo.map(hotel => ({
            ...hotel,
            hotel_id:  hotel.hotel_id || hotel.id,
            salesFlag: hotel.sFlag    || 'Y',
            adminMemo: hotel.adminMemo || '',
            dispOrder: hotel.dispOrder || 999,
            checkFlag: false,
            margin: hotel.margin || 0,
            marginMethod: hotel.marginMethod || 'P',

            // ✅ store의 rakutenImageHost + hotel_id + 파일명 조합
            heroImg: hotel.heroImg
              ? `${this.rakutenImageHost}/${hotel.hotel_id || hotel.id}/${hotel.heroImg}`
              : null
          }));

          this.filteredHotels = [...this.allHotels];
          this.allSelected = false;
          this.currentPage = 1;

          this.$swal({
            icon: 'success', title: '로딩 완료',
            text: `${this.allHotels.length}개 호텔 정보를 불러왔습니다.`,
            timer: 1500, showConfirmButton: false
          });
        } 
        else 
        {
          this.allHotels = [];
          this.filteredHotels = [];
          this.currentPage = 1;
        }
      } 
      catch (error) 
      {
        console.error("DB 조회 오류:", error);
        this.error = error.message;
      } 
      finally 
      {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    },

    async getLastSyncDate() {
      let lastSync = await this.$api("/api/getRakuLastSyncDate", {});
      this.lastSyncDate = lastSync.length > 0 ? lastSync[0].syncDate : null;
    },

    async fetchPropertyDetails(propertyCodes, propertyInfoMap = {}) {
      if (!propertyCodes || propertyCodes.length === 0) return [];

      const chunks = this.chunkArray(propertyCodes, 100);
      let allHotelDetails = [];

      for (let i = 0; i < chunks.length; i++) {
        this.loadingMessage = `배치 ${i + 1}/${chunks.length} 처리 중... (${this.getLanguageName(this.selectedLanguage)})`;

        try {
          const result = await this.$api("/api/rakuten/postProperties", {
            param: [{
              property_codes: chunks[i],
              extends: ['long', 'facilities', 'images'],
              language: this.selectedLanguage
            }]
          });

          if (result.success && result.data) {
            const hotels = Object.values(result.data);
            const enrichedHotels = hotels.map(hotel => {
              const additionalInfo = propertyInfoMap[hotel.id] || {};
              return {
                ...hotel,
                is_active: additionalInfo.is_active !== undefined
                  ? additionalInfo.is_active : hotel.is_active,
                activated_at: additionalInfo.activated_at || hotel.activated_at || null,
                deactivated_at: additionalInfo.deactivated_at || hotel.deactivated_at || null
              };
            });
            allHotelDetails = [...allHotelDetails, ...enrichedHotels];
          }
        } catch (error) {
          console.error(`배치 ${i + 1} 처리 중 오류:`, error);
        }
      }

      this.loadingMessage = '';
      return allHotelDetails;
    },

    /**
     * ✅ 수정: pagination.next 기준으로 종료 판단
     */
    async getMyPropertyList(options = {}) {
      this.loading = true;
      this.loadingMessage = '호텔 코드 목록 조회 중...';
      this.error = null;

      try {
        let allProperties = [];
        let currentPage = 1;
        let hasMore = true;
        const propertyInfoMap = {};

        while (hasMore) {
          this.loadingMessage = `호텔 코드 목록 조회 중... (페이지 ${currentPage})`;

          let result = await this.$api("/api/rakuten/getMyPropertyList", {
            param: [{
              since: options.since || null,
              page: currentPage,
              size: 1000
            }]
          });

          if (!result.success || !result.data) break;

          let myPropertyList = result.data.my_property_list || [];
          if (myPropertyList.length === 0) break;

          myPropertyList.forEach(p => {
            propertyInfoMap[p.property_code] = {
              is_active: p.is_active,
              activated_at: p.activated_at,
              deactivated_at: p.deactivated_at
            };
          });

          const propertyCodes = myPropertyList.map(p => p.property_code);
          const hotelDetails = await this.fetchPropertyDetails(propertyCodes, propertyInfoMap);
          allProperties = [...allProperties, ...hotelDetails];

          // ✅ 수정: pagination.next 기준으로 종료 판단
          if (!result.data.pagination?.next) {
            hasMore = false;
          } else {
            currentPage++;
          }
        }

        if (allProperties.length === 0) {
          this.$swal({ icon: 'info', title: '조회 결과 없음', text: '조회된 호텔이 없습니다.' });
          return null;
        }

        this.allHotels = allProperties;
        this.filteredHotels = [...this.allHotels];
        this.currentPage = 1;

        this.$swal({
          icon: 'success', title: '조회 완료!',
          text: `${allProperties.length}개 호텔의 상세정보를 가져왔습니다.`,
          timer: 2000, showConfirmButton: false
        });

        return allProperties;

      } catch (error) {
        console.error("❌ 호텔 조회 오류:", error);
        this.error = error.message;
        this.$swal({ icon: 'error', title: '조회 실패', text: error.message });
        return null;
      } finally {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    /**
     * ✅ 수정: size 10000 → 페이지 순회로 변경 + pagination.next 기준 종료
     */
    async getUpdatedProperties() {
      if (!this.lastSyncDate) 
      {
        this.$swal({ icon: 'info', title: '초기 동기화 필요', text: '먼저 전체 호텔 목록을 조회해주세요.' });
        return;
      }

      this.loading = true;
      this.loadingMessage = '변경사항 확인 중...';
      this.error = null;

      try 
      {
        const changelogResult = await this.$api("/api/rakuten/getChangedHotelIds", {
          param: [{ updatedAtFrom: this.lastSyncDate }]
        });

        if (!changelogResult.success) 
        {
          throw new Error(changelogResult.message || '변경사항 조회 실패');
        }

        const changedHotelIds = changelogResult.hotelIds || [];

        if (changedHotelIds.length < 1) 
        {
          this.$swal({
            icon: 'info', title: '변경사항 없음',
            text: '최근 동기화 이후 변경된 호텔이 없습니다.',
            timer: 2000, showConfirmButton: false
          });
          return;
        }

        //console.log(`✅ ${changedHotelIds.length}개 호텔 변경됨`);

        // ✅ 수정: size 10000 → 페이지 순회로 변경
        //console.log("🔵 MyPropertyList에서 추가 정보 조회 중...");
        const propertyInfoMap = {};
        let page = 1;
        let hasMore = true;

        while (hasMore) 
        {
          const myPropertiesResult = await this.$api("/api/rakuten/getMyPropertyList", {
            param: [{
              since: null,
              page: page,
              size: 1000  // ✅ API 최대값 1000으로 변경
            }]
          });

          if (myPropertiesResult.success && myPropertiesResult.data) 
          {
            const myPropertyList = myPropertiesResult.data.my_property_list || [];

            // 변경된 호텔만 필터링하여 map에 추가
            myPropertyList
              .filter(p => changedHotelIds.includes(p.property_code))
              .forEach(p => {
                propertyInfoMap[p.property_code] = {
                  is_active: p.is_active,
                  activated_at: p.activated_at,
                  deactivated_at: p.deactivated_at
                };
              });

            // ✅ pagination.next 기준으로 종료 판단
            if (!myPropertiesResult.data.pagination?.next) 
            {
              hasMore = false;
            } 
            else 
            {
              page++;
            }
          } 
          else 
          {
            hasMore = false;
          }
        }

        // console.log(`✅ PropertyInfoMap 생성: ${Object.keys(propertyInfoMap).length}개`);

        this.loadingMessage = `${changedHotelIds.length}개 호텔 상세정보 조회 중...`;
        const updatedHotels = await this.fetchPropertyDetails(changedHotelIds, propertyInfoMap);

        if (!updatedHotels || updatedHotels.length < 1) {
          throw new Error('호텔 상세정보 조회 실패');
        }

        this.allHotels = updatedHotels;
        this.filteredHotels = [...this.allHotels];
        this.currentPage = 1;

        const saveResult = await this.$swal({
          title: '변경된 호텔 조회 완료',
          html: `
            <p><strong>${updatedHotels.length}개</strong> 호텔이 변경되었습니다.</p>
            <p style="color: #666; font-size: 14px;">언어: ${this.getLanguageName(this.selectedLanguage)}</p>
            <p style="color: #007bff; font-size: 12px;">💡 변경된 호텔만 업데이트됩니다.</p>
          `,
          icon: 'question',
          showCancelButton: true,
          //confirmButtonText: '저장하기',
          cancelButtonText: '변경된 호텔리스트',
          confirmButtonColor: '#28a745'
        });

        if (saveResult.isConfirmed) 
        {
          // await this.saveChangedHotels(updatedHotels);
          this.$swal({
            icon: 'success', title: '변경사항 조회 완료!',
            text: `${updatedHotels.length}개 호텔을 가져왔습니다.`,
            timer: 2000, showConfirmButton: false
          });

        } 
        else 
        {
          this.$swal({
            icon: 'success', title: '변경사항 조회 완료!',
            text: `${updatedHotels.length}개 호텔을 가져왔습니다.`,
            timer: 2000, showConfirmButton: false
          });
        }

        return updatedHotels;

      } 
      catch (error) 
      {
        console.error("❌ 변경사항 조회 오류:", error);
        this.error = error.message;
        this.$swal({ icon: 'error', title: '조회 실패', text: error.message });
        return null;
      } 
      finally 
      {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    async saveChangedHotels(hotels) {
      this.loading = true;
      try {
        const batchSize = 100;
        const totalCount = hotels.length;
        let processedCount = 0;
        let failedCount = 0;

        for (let i = 0; i < totalCount; i += batchSize) {
          const batch = hotels.slice(i, i + batchSize);
          this.loadingMessage = `변경사항 저장 중... (${Math.min(i + batchSize, totalCount)}/${totalCount})`;

          const hotelsData = {};
          batch.forEach(hotel => { hotelsData[hotel.id] = hotel; });

          try {
            const result = await this.$api("/api/rakuten/saveHotelsData", {
              param: [{ hotelsData, language: this.selectedLanguage }]
            });
            if (result.success) {
              processedCount += result.stats.processed;
              failedCount += result.stats.failed;
            }
          } catch (batchError) {
            console.error(`배치 저장 실패:`, batchError);
            failedCount += batch.length;
          }

          if (i + batchSize < totalCount) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }

        this.$swal({
          icon: failedCount === 0 ? 'success' : 'warning',
          title: '저장 완료!',
          html: `
            <div style="text-align: left;">
              <p>✅ 성공: <strong>${processedCount}개</strong></p>
              <p>❌ 실패: <strong>${failedCount}개</strong></p>
            </div>
          `,
          timer: failedCount > 0 ? undefined : 2000,
          showConfirmButton: failedCount > 0
        });

      } catch (error) {
        console.error("저장 오류:", error);
        this.$swal({ icon: 'error', title: '저장 실패', text: error.message });
      } finally {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    // 호텔정보 변경사항 동기화
    async syncChanges() {
      if (!this.lastSyncDate) 
      {
        this.$swal({ icon: 'info', title: '동기화 기준 없음', text: '먼저 호텔 동기화를 진행해주세요.' });
        return;
      }

      await this.getLastSyncDate();

      if (!this.lastSyncDate) 
      {
        this.$swal({ icon: 'warning', title: '동기화 기준 없음', text: 'DB에 동기화 이력이 없습니다.' });
        return;
      }

      const confirm = await this.$swal({
        title: '변경사항 통합 동기화',
        html: `
          <p>마지막 동기화 이후 변경사항을 한번에 업데이트합니다.</p>
          <p style="color:#666; font-size:13px;">기준일: <strong>${this.getLocaleDateFormat(this.lastSyncDate)}</strong></p>
          <ul style="text-align:left; font-size:13px; color:#555; margin-top:10px; padding-left:20px;">
            <li>호텔정보 변경분 동기화</li>
            <li>객실정보 변경분 동기화</li>
            <li>신규 호텔의 객실정보 자동 수집</li>
          </ul>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '동기화 시작',
        cancelButtonText: '취소',
        confirmButtonColor: '#17a2b8'
      });

      if (!confirm.isConfirmed) return;

      this.loading = true;
      this.loadingMessage = '변경사항 동기화 중...';

      try 
      {
        const result = await this.$api('/api/rakuten/syncChanges', {
          param: [{
            updatedAtFrom: this.lastSyncDate,
            language:      this.selectedLanguage
          }]
        });

        if (result.success) 
        {
          this.$swal({
            icon: 'success',
            title: '동기화 완료!',
            html: `
              <div style="text-align:left;">
                <p>🏨 호텔정보: <strong>${result.stats.hotel.processed}개</strong> 업데이트
                  (실패 ${result.stats.hotel.failed}개)</p>
                <p>🛏️ 객실정보: <strong>${result.stats.room.total_rooms}개</strong>
                  (${result.stats.room.processed}개 호텔, 실패 ${result.stats.room.failed}개)</p>
              </div>
            `,
            timer: 4000,
            showConfirmButton: true
          });
        } 
        else 
        {
          throw new Error(result.message);
        }
      } 
      catch (e) 
      {
        this.$swal({ icon: 'error', title: '동기화 실패', text: e.message });
      } 
      finally 
      {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    // // ✅ 추가: syncRoomsV2 - 변경된 객실만 동기화
    // async syncRoomsV2() {
    //   if (!this.lastSyncDate) 
    //   {
    //     this.$swal({ icon: 'question', title: '동기화 기준 없음', text: '먼저 호텔 동기화를 진행해주세요.' });
    //     return;
    //   }

    //   // 최신 동기화 시간갱신
    //   await this.getLastSyncDate()

    //   // ✅ 재조회 후에도 null 체크
    //   if (!this.lastSyncDate) 
    //   {
    //     this.$swal({ icon: 'warning', title: '동기화 기준 없음', text: 'DB에 동기화 이력이 없습니다.' });
    //     return;
    //   }

    //   const result = await this.$swal({
    //     title: '객실 동기화',
    //     html: `
    //       <p>마지막 동기화 이후 변경된 객실을 업데이트합니다.</p>
    //       <p style="color: #666; font-size: 13px;">기준일: <strong>${this.getLocaleDateFormat(this.lastSyncDate)}</strong></p>
    //       <p style="color: #007bff; font-size: 12px;">💡 Rooms V2 API를 사용합니다.</p>
    //     `,
    //     icon: 'question',
    //     showCancelButton: true,
    //     confirmButtonText: '동기화 시작',
    //     cancelButtonText: '취소',
    //     confirmButtonColor: '#17a2b8'
    //   });

    //   if (!result.isConfirmed) return;

    //   this.loading = true;
    //   this.loadingMessage = '변경된 객실 동기화 중...';

    //   try 
    //   {
    //     const syncResult = await this.$api("/api/rakuten/syncRoomsV2", {
    //       param: [{
    //         updatedAtFrom: this.lastSyncDate,
    //         language: this.selectedLanguage
    //       }]
    //     });

    //     if (syncResult.success) 
    //     {
    //       this.$swal({
    //         icon: 'success',
    //         title: '객실 동기화 완료!',
    //         html: `
    //           <div style="text-align: left;">
    //             <p>✅ 성공: <strong>${syncResult.processed}개</strong> 호텔</p>
    //             <p>❌ 실패: <strong>${syncResult.failed}개</strong></p>
    //             <p>🛏️ 총 객실: <strong>${syncResult.total_rooms}개</strong></p>
    //           </div>
    //         `,
    //         timer: syncResult.failed > 0 ? undefined : 3000,
    //         showConfirmButton: syncResult.failed > 0
    //       });
    //     } 
    //     else 
    //     {
    //       throw new Error(syncResult.message || '객실 동기화 실패');
    //     }

    //   } 
    //   catch (error) 
    //   {
    //     console.error("❌ 객실 동기화 오류:", error);
    //     this.$swal({ icon: 'error', title: '동기화 실패', text: error.message });
    //   } 
    //   finally 
    //   {
    //     this.loading = false;
    //     this.loadingMessage = '';
    //   }
    // },


    /**
     * ✅ 수정: pagination.next 기준으로 종료 판단
     */
    async getAllProperties() {
      let allProperties = [];
      let currentPage = 1;
      let hasMore = true;

      this.loading = true;
      this.loadingMessage = '전체 호텔 목록 다운로드 중...';
      const propertyInfoMap = {};

      try {
        while (hasMore) {
          this.loadingMessage = `페이지 ${currentPage} 조회 중...`;

          let result = await this.$api("/api/rakuten/getMyPropertyList", {
            param: [{ since: null, page: currentPage, size: 1000 }]
          });

          if (result.success && result.data && result.data.my_property_list) {
            const myPropertyList = result.data.my_property_list;

            myPropertyList.forEach(p => {
              propertyInfoMap[p.property_code] = {
                is_active: p.is_active,
                activated_at: p.activated_at,
                deactivated_at: p.deactivated_at
              };
            });

            const propertyCodes = myPropertyList.map(p => p.property_code);
            if (propertyCodes.length > 0) {
              const hotelDetails = await this.fetchPropertyDetails(propertyCodes, propertyInfoMap);
              allProperties = [...allProperties, ...hotelDetails];
            }

            // ✅ 수정: pagination.next 기준으로 종료 판단
            if (!result.data.pagination?.next) {
              hasMore = false;
            } else {
              currentPage++;
            }
          } else {
            hasMore = false;
          }
        }

        this.allHotels = allProperties;
        this.filteredHotels = [...this.allHotels];
        this.currentPage = 1;
        this.lastSyncDate = new Date().toISOString();

        this.$swal("전체조회완료", `총 ${allProperties.length}개의 호텔을 조회했습니다.`, "success");
        return allProperties;

      } catch (error) {
        console.error("전체 조회 오류:", error);
        this.error = error.message;
        this.$swal("조회 실패", `${error.message}`, "error");
        return null;
      } finally {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    async syncToDatabase() {
      if (this.allHotels.length === 0) {
        this.$swal({ icon: 'warning', title: '저장할 데이터 없음', text: '먼저 호텔 목록을 조회해주세요.' });
        return;
      }

      const result = await this.$swal({
        title: 'DB 저장 확인',
        html: `
          <p><strong>${this.allHotels.length}개</strong> 호텔을 DB에 저장하시겠습니까?</p>
          <p style="color: #666; font-size: 14px;">언어: ${this.getLanguageName(this.selectedLanguage)}</p>
          <p style="color: #dc3545; font-size: 12px;">⚠️ 기존 데이터는 업데이트됩니다.</p>
          <p style="color: #007bff; font-size: 12px;">💡 100개씩 나눠서 저장합니다.</p>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '저장',
        cancelButtonText: '취소',
        confirmButtonColor: '#28a745'
      });

      if (!result.isConfirmed) return;

      this.loading = true;

      try {
        const batchSize = 100;
        const totalCount = this.allHotels.length;
        let processedCount = 0;
        let failedCount = 0;
        const errors = [];

        for (let i = 0; i < totalCount; i += batchSize) {
          const batch = this.allHotels.slice(i, i + batchSize);
          this.loadingMessage = `DB 저장 중... (${processedCount + batch.length}/${totalCount})`;

          const hotelsData = {};
          batch.forEach(hotel => { hotelsData[hotel.id] = hotel; });

          try {
            const syncResult = await this.$api("/api/rakuten/saveHotelsData", {
              param: [{ hotelsData, language: this.selectedLanguage }]
            });

            if (syncResult.success) {
              processedCount += syncResult.stats.processed;
              failedCount += syncResult.stats.failed;
              if (syncResult.errors?.length > 0) errors.push(...syncResult.errors);
            } else {
              throw new Error(syncResult.message || 'DB 저장 실패');
            }
          } catch (batchError) {
            failedCount += batch.length;
            errors.push({ range: `${i}-${i + batch.length}`, error: batchError.message });
          }

          if (i + batchSize < totalCount) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }

        if (processedCount > 0) await this.insSyncDate();

        this.$swal({
          icon: failedCount === 0 ? 'success' : 'warning',
          title: '저장 완료!',
          html: `
            <div style="text-align: left;">
              <p>✅ 성공: <strong>${processedCount}개</strong></p>
              <p>❌ 실패: <strong>${failedCount}개</strong></p>
              <p>🌐 언어: <strong>${this.getLanguageName(this.selectedLanguage)}</strong></p>
            </div>
          `,
          timer: failedCount > 0 ? undefined : 3000,
          showConfirmButton: failedCount > 0
        });

      } catch (error) {
        console.error("DB 저장 오류:", error);
        this.$swal({ icon: 'error', title: 'DB 저장 실패', text: error.message });
      } finally {
        this.loading = false;
        this.loadingMessage = '';
      }
    },

    // ✅ 추가: 전체 객실 초기 동기화
    async syncAllRoomsV2() {
      const result = await this.$swal({
        title: '⚠️ 전체 객실 초기 동기화',
        html: `
          <p>전체 호텔의 객실 정보를 가져옵니다.</p>
          <p style="color: #dc3545; font-weight: bold;">처리시간은 각 호텔의 총 객실수에 비례합니다</p>
          <p style="color: #666; font-size: 13px;">백그라운드에서 처리되며 수십 분 소요됩니다.</p>
          <p style="color: #007bff; font-size: 12px;">💡 최초 1회 또는 전체 재동기화 시에만 사용하세요.</p>
          <p style="color: #28a745; font-size: 12px;">✅ 이후 변경분은 "변경된 객실 동기화" 버튼을 사용하세요.</p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '시작',
        cancelButtonText: '취소',
        confirmButtonColor: '#6c757d'
      });

      if (!result.isConfirmed) return;

      try 
      {
        // ✅ 백그라운드 처리이므로 즉시 응답
        const syncResult = await this.$api("/api/rakuten/syncAllRoomsV2", {
          param: [{ language: this.selectedLanguage }]
        });

        if (syncResult.success) 
        {
          this.$swal({
            icon: 'info',
            title: '백그라운드 동기화 시작됨',
            html: `
              <p>${syncResult.message}</p>
              <p style="color: #666; font-size: 13px;">서버 콘솔에서 진행상황을 확인하세요.</p>
            `,
            confirmButtonText: '확인'
          });
        }
      } 
      catch (error) 
      {
        this.$swal({ icon: 'error', title: '시작 실패', text: error.message });
      }
    },


    async insSyncDate() {
      try {
        let result = await this.$api("/api/insRakuSyncDate", { param: [this.user.handlerId] });
        if (result.affectedRows < 1) {
          this.$swal({ icon: 'warning', text: '동기화 일시의 저장에 오류가 발생했습니다. 재시도해주세요.' });
          return false;
        }
        await this.getLastSyncDate();
        return true;
      } catch (error) {
        console.error("동기화 날짜 저장 오류:", error);
      }
    },

    formatAddress(hotel) {
      if (!hotel) return '-';
      if (hotel.address) return hotel.address;
      return [hotel.city, hotel.country].filter(Boolean).join(', ') || '-';
    },

    //호텔설명
    viewDetail(hotel) { 
      this.selectedHotel = hotel; 
    },

    //모달닫기
    closeModal() { this.selectedHotel = null; },
    //호텔설명수정X
    editHotel(hotel) {
      this.$swal({ icon: 'info', title: '준비 중', text: '호텔 수정 기능은 준비 중입니다.', hotel });
    },

    // 선택호텔의 객실정보
    async viewRooms(hId, hName) {
      this.roomList = [];
      this.roomLoading = true;

      this.selectedRoomHotel = { id: hId, name: hName};

      try 
      {
        const result = await this.$api("/api/rakutenHotelRoomsInfo", {param: [hId]});
        this.roomList = result || [];
      } 
      catch (error) 
      {
        console.error("객실 조회 오류:", error);
        this.$swal({ icon: 'error', title: '객실 조회 실패', text: error.message });
      } 
      finally 
      {
        this.roomLoading = false;
      }
    },

    closeRoomModal() {
      this.selectedRoomHotel = null;
      this.roomList = [];
    },
  }
};
</script>

<style scoped>
/* 기존 스타일 + 추가 스타일 */
.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.hotel-description {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
}

.rakuten-hotel-container {
  max-width: 90%;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.page-header h1 {
  font-size: 28px;
  color: #333;
  margin: 0;
}

.sync-info {
  color: #666;
  font-size: 14px;
}

.search-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.search-section2 {
  background: #e2e9ef;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.search-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.form-group {
  display: flex;
  flex-direction: column;
  min-width: 150px;
}

.form-group2 {
  display: flex;
  flex-direction: column;
  min-width: 60px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #555;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.button-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btnForAdmin {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;  
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0056b3;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-info {
  background: #17a2b8;
  color: white;
}

.btn-warning {
  background: #ffc107;
  color: #333;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  background: white;
  padding: 40px;
  border-radius: 8px;
  text-align: center;
}

.rakuten-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-alert {
  margin-bottom: 20px;
}

.alert {
  padding: 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-danger {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.close-btn {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #721c24;
}

.result-summary {
  margin-bottom: 20px;
}

.summary-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.summary-card h3 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #333;
}

.summary-stats {
  display: flex;
  gap: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
}

.thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.hotel-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow-x: auto;
  margin-bottom: 20px;
}

.hotel-table {
  width: 100%;
  border-collapse: collapse;
}

.hotel-table thead {
  background: #f8f9fa;
}

.hotel-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.hotel-table td {
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
}

.hotel-table tbody tr:hover {
  background: #f8f9fa;
}

.hotel-name {
  max-width: 150px;
  font-weight: 500;
}

.hotel-address {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-active {
  background: #d4edda;
  color: #155724;
}

.status-inactive {
  background: #f8d7da;
  color: #721c24;
}

.text-center {
  text-align: center;
}

.adminMemo {
  font-size: 0.8rem;
  color: darkcyan;
}

.btn-action {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  transition: all 0.3s;
}

.btn-view {
  background: #17a2b8;
  color: white;
}

.btn-view2 {
  background: #0e9307;
  color: white;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.empty-state h3 {
  color: #333;
  margin-bottom: 10px;
}

.empty-state p {
  color: #666;
  margin-bottom: 20px;
}

/* ⭐ 페이징 관련 추가 스타일 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn-pagination {
  padding: 8px 20px;
}

.page-info {
  font-weight: 500;
  color: #333;
  font-size: 16px;
}

.page-jump {
  display: flex;
  gap: 5px;
  align-items: center;
}

.page-input {
  width: 80px;
  padding: 6px 10px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
}

.modal-close {
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: #666;
  line-height: 1;
}

.modal-body {
  padding: 20px;
}

.detail-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row label {
  font-weight: 600;
  width: 120px;
  color: #555;
}

.detail-row span,
.detail-row p {
  flex: 1;
  color: #333;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

  /**
    thumbnail: 썸네일 이미지 스타일 
  */
  .thumb-wrap {
    position: relative;
    display: inline-block;
  }

  .thumbnail {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    display: block;
  }

  /* ✅ 기본: 숨김 */
  .thumb-preview {
    display: none;
    position: fixed;
    z-index: 9999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
    padding: 8px;
    pointer-events: none;
  }

  /* ✅ hover 시: 표시 */
  .thumb-wrap:hover .thumb-preview {
    display: block;
  }

  .thumb-preview img {
    width: 600px;
    height: auto;
    object-fit: cover;
    border-radius: 4px;
    display: block;
  }

  .thumb-preview-name {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #555;
    text-align: center;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }


@media (max-width: 768px) {
  .search-row {
    flex-direction: column;
  }
  
  .form-group {
    width: 100%;
  }
  
  .button-group {
    width: 100%;
  }
  
  .button-group .btn {
    flex: 1;
  }
  
  .summary-stats {
    flex-direction: column;
    gap: 15px;
  }
  
  .hotel-table {
    font-size: 12px;
  }
  
  .hotel-table th,
  .hotel-table td {
    padding: 8px;
  }

  .pagination {
    flex-direction: column;
  }

  .page-jump {
    width: 100%;
  }

  .page-input {
    flex: 1;
  }
}
</style>